// extracted by mini-css-extract-plugin
module.exports = {"optionsList":"brightness-controller_optionsList__HGvRK","icon":"brightness-controller_icon__3wkch"};